import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { HelmetProvider } from 'react-helmet-async';
import { logger } from './lib/logger';
import { initPosthog, initCookielessPosthog } from './lib/posthog';
import { getAnalyticsConsent } from './lib/consent';

// Note: Sentry is intentionally not imported to avoid adding a new dependency
// during MVP hardening. We can enable Sentry later via a small PR.

// Initialize analytics only if consent already granted
try {
  const consent = getAnalyticsConsent();
  if (consent === true) {
    initPosthog();
  } else if (consent === null) {
    // No choice yet: run minimal cookieless pageview-only until the user decides
    initCookielessPosthog();
  }
} catch (error) {
  // Silently fail analytics initialization - don't block app startup
  console.warn('Analytics initialization failed:', error);
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
